import { privateAPI } from '../../config/constants'
import { decrypt, gettokenData } from '../../functions/globalFunctions'

export const getAllAlertsCounts = () => {
  return async () => {
    const res = await privateAPI.post(`/alerts/get-all-alerts-count`, {
      data: {
        vendorId: gettokenData()?.vendorId,
      },
    })
    if (res) {
      let resp = decrypt(res.data)
      //
      return resp
    }
  }
}

export const getTop100CustomerLastMonthData = () => {
  return async () => {
    const res = await privateAPI.post(`/alerts/top-100-cus-last-6Month-true`, {
      data: {
        vendorId: gettokenData()?.vendorId,
      },
    })
    if (res) {
      let resp = decrypt(res.data)
      return resp
    }
  }
}

export const getTop100CustomerLastMonthPurchasedData = () => {
  return async () => {
    const res = await privateAPI.post(`/alerts/top-100-cus-last-6Month-purchased`, {
      data: {
        vendorId: gettokenData()?.vendorId,
      },
    })
    if (res) {
      let resp = decrypt(res.data)
      return resp
    }
  }
}

export const getTop100CustomerLast6MonthDataNotPurchased = () => {
  return async () => {
    const res = await privateAPI.post(`/alerts/top-100-cus-last-6Month-not-purchased`, {
      data: {
        vendorId: gettokenData()?.vendorId,
      },
    })
    if (res) {
      let resp = decrypt(res.data)
      //
      return resp
    }
  }
}

export const getTop10ProdLast6Month = () => {
  return async () => {
    const res = await privateAPI.post(`/alerts/top-10-prod-last-6Month`, {
      data: {
        vendorId: gettokenData()?.vendorId,
      },
    })
    if (res) {
      let resp = decrypt(res.data)
      //
      return resp
    }
  }
}
export const getTop10ProdLast6MonthNumbers = (data) => {
  return async () => {
    const res = await privateAPI.post(`/alerts/top-10-prod-last-6Month-numbers`, {
      data: {
        vendorId: gettokenData()?.vendorId,
        data,
      },
    })
    if (res) {
      let resp = decrypt(res.data)
      //
      return resp
    }
  }
}

export const getTop10StorePerfLast6Month = () => {
  return async () => {
    const res = await privateAPI.post(`/alerts/top-10-store-perf-last-month`, {
      data: {
        vendorId: gettokenData()?.vendorId,
      },
    })
    if (res) {
      let resp = decrypt(res.data)
      //
      return resp
    }
  }
}
export const getTop10StorePerfLast6MonthNumbers = (data) => {
  return async () => {
    const res = await privateAPI.post(`/alerts/top-10-store-perf-last-month-numbers`, {
      data: {
        vendorId: gettokenData()?.vendorId,
        data,
      },
    })
    if (res) {
      let resp = decrypt(res.data)
      //
      return resp
    }
  }
}

export const getReturningCustomerRateLast3Month = () => {
  return async () => {
    const res = await privateAPI.post(`/alerts/get-returning-customer-rate-last-3month`, {
      data: {
        vendorId: gettokenData()?.vendorId,
      },
    })
    if (res) {
      let resp = decrypt(res.data)
      //
      return resp
    }
  }
}
export const getReturningCustomerRateLast3MonthNumbers = (data) => {
  return async () => {
    const res = await privateAPI.post(`/alerts/get-returning-customer-rate-last-3month-numbers`, {
      data: {
        vendorId: gettokenData()?.vendorId,
        data,
      },
    })
    if (res) {
      let resp = decrypt(res.data)
      //
      return resp
    }
  }
}

export const getLostCustomer = () => {
  return async () => {
    const res = await privateAPI.post(`/alerts/get-lost-customer`, {
      data: {
        vendorId: gettokenData()?.vendorId,
      },
    })
    if (res) {
      let resp = decrypt(res.data)
      //
      return resp
    }
  }
}

export const getNewCustomerLastWeek = () => {
  return async () => {
    const res = await privateAPI.post(`/alerts/get-new-customer-last-week`, {
      data: {
        vendorId: gettokenData()?.vendorId,
      },
    })
    if (res) {
      let resp = decrypt(res.data)
      //
      return resp
    }
  }
}

export const getMostProdCatbyReturningCustomer = () => {
  return async () => {
    const res = await privateAPI.post(`/alerts/get-most-product-category-returning-customer`, {
      data: {
        vendorId: gettokenData()?.vendorId,
      },
    })
    if (res) {
      let resp = decrypt(res.data)
      //
      return resp
    }
  }
}
export const getMostProdCatbyReturningCustomerNumber = (data) => {
  return async () => {
    const res = await privateAPI.post(
      `/alerts/get-most-product-category-returning-customer-numbers`,
      {
        data: {
          vendorId: gettokenData()?.vendorId,
          data,
        },
      },
    )
    if (res) {
      let resp = decrypt(res.data)
      //
      return resp
    }
  }
}

export const getStarCustomerLast6Month = () => {
  return async () => {
    const res = await privateAPI.post(`/alerts/get-star-customer-last-6month`, {
      data: {
        vendorId: gettokenData()?.vendorId,
      },
    })
    if (res) {
      let resp = decrypt(res.data)
      //
      return resp
    }
  }
}

export const getNeedAttentionCustomerLastMonth = () => {
  return async () => {
    const res = await privateAPI.post(`/alerts/get-need-attention-customer-last-month`, {
      data: {
        vendorId: gettokenData()?.vendorId,
      },
    })
    if (res) {
      let resp = decrypt(res.data)
      //
      return resp
    }
  }
}

export const getDiscountHunter = () => {
  return async () => {
    const res = await privateAPI.post(`/alerts/get-discount-hunter`, {
      data: {
        vendorId: gettokenData()?.vendorId,
      },
    })
    if (res) {
      let resp = decrypt(res.data)
      //
      return resp
    }
  }
}

export const getAboutToGoNeedAttentionCustomer = () => {
  return async () => {
    const res = await privateAPI.post(`/alerts/get-about-to-go-need-attention-customer`, {
      data: {
        vendorId: gettokenData()?.vendorId,
      },
    })
    if (res) {
      let resp = decrypt(res.data)
      //
      return resp
    }
  }
}

export const getAboutToGoRiskCustomer = () => {
  return async () => {
    const res = await privateAPI.post(`/alerts/get-about-to-go-at-risk-customer`, {
      data: {
        vendorId: gettokenData()?.vendorId,
      },
    })
    if (res) {
      let resp = decrypt(res.data)
      //
      return resp
    }
  }
}

export const getAboutToGoLostCustomer = () => {
  return async () => {
    const res = await privateAPI.post(`/alerts/get-about-to-go-lost-customer`, {
      data: {
        vendorId: gettokenData()?.vendorId,
      },
    })
    if (res) {
      let resp = decrypt(res.data)
      //
      return resp
    }
  }
}
